import advantages from "../../settings/firmwareAdvantages.json";

export default function FirmwareAdvantages() {
  return (
    <div className="firmwareContentSide">
      <div className="firmwareAdvantages">Кастомные прошивки позволяют</div>
      <div className="firmwareAdvantagesItems">
        {advantages.map((el, i) => (
          <div className="firmwareAdvantagesItem" key={i}>
            <div className="firmwareAdvantagesItemNumberWrapper">
              <div className="firmwareAdvantagesItemNumber no-border">
                <img
                  className={"giCheckMark"}
                  src={"/assets/img/check-mark-blue.svg"}
                  alt={"Check mark"}
                />
              </div>
            </div>
            <div className="firmwareAdvantagesItemText">{el}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
